function getThemeFromLocalStorage() {
	if (window.localStorage.getItem('dark')) {
	  return JSON.parse(window.localStorage.getItem('dark'))
	}
	return (!!window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches)
}
function setThemeToLocalStorage(value) {
	window.localStorage.setItem('dark', value);
}
function getPostSelectedFromLocalStorage() {
	if (window.localStorage.getItem('postselected')) {
	  return JSON.parse(window.localStorage.getItem('postselected'))
	}
	return 0;
}
function getPostSelectedHeightFromLocalStorage() {
	if (window.localStorage.getItem('selectedHeight')) {
	  return JSON.parse(window.localStorage.getItem('selectedHeight'))
	}
	return 0;
}
function setPostSelectedToLocalStorage(value,height) {
	window.localStorage.setItem('postselected', value);
	window.localStorage.setItem('selectedHeight', height);
}
function getRecentedVisted(){
	if (window.localStorage.getItem('recent-visited')) {
	  return  JSON.parse(window.localStorage.getItem('recent-visited'))
	}
	return [];
}
function setRecentedVisted(url){
	var r =[];
	if (window.localStorage.getItem('recent-visited')) {
	  var r =  JSON.parse(window.localStorage.getItem('recent-visited'))
	}
	r.unshift(url);
	r = r.slice(0, 10);
	window.localStorage.setItem("recent-visited", JSON.stringify([...new Set(r)]));
}
export default () => ({
	dark: getThemeFromLocalStorage(),
	postselected: getPostSelectedFromLocalStorage(),
	filter: '',
	recentVisited: getRecentedVisted(),
	menuOpen:false,
	show: false,
	selected: null,
	focusedOptionIndex: null,
	options: null,
	openModel(type=''){
		if(type=='add'){
			document.getElementById("add").click();
		}else{
			document.getElementById("openModel").click();
		}
	},
	close() { 
	  this.show = false;
	  this.filter = this.selectedName();
	  this.focusedOptionIndex = this.selected ? this.focusedOptionIndex : null;
	},
	open() { 
	  this.show = true; 
	  this.filter = '';
	},
	toggle() { 
	  if (this.show) {
		this.close();
	  }
	  else {
		this.open()
	  }
	},
	isOpen() { return this.show === true },
	selectedName() { return this.selected ? this.selected.menu_name : this.filter; },
	classOption(id, index) {
	  const isSelected = this.selected ? (id == this.selected.id) : false;
	  const isFocused = (index == this.focusedOptionIndex);
	  return {
		'cursor-pointer w-full border-gray-100 border-b dark:hover:bg-gray-900 hover:bg-blue-50': true,
		'bg-blue-100': isSelected,
		'bg-blue-50': isFocused
	  };
	},
	fetchOptions() {
	  fetch('/menudetails/pre_post')
		.then(response => response.json())
		.then(data => this.options = data);
	},
	filteredOptions() {
	  return this.options
		? this.options.data.filter(option => {
			return (option.menu_name.toLowerCase().indexOf(this.filter) > -1) 
			  || (option.menu_url.toLowerCase().indexOf(this.filter) > -1)
		})
	   : {}
	},
	onOptionClick(index) {
	  this.focusedOptionIndex = index;
	  this.selectOption();
	},
	selectOption() {
		if (!this.isOpen()) {
			return;
		}
		this.focusedOptionIndex = this.focusedOptionIndex ?? 0;
		const selected = this.filteredOptions()[this.focusedOptionIndex]
		this.selected = selected;
		this.close();
		var getUrl = window.location;
		window.location.href=getUrl.protocol + "//" + getUrl.host + "/" + getUrl.pathname.split('/')[1]+"/"+this.selected.menu_url;
	},
	focusPrevOption() {
	  if (!this.isOpen()) {
		return;
	  }
	  const optionsNum = Object.keys(this.filteredOptions()).length - 1;
	  if (this.focusedOptionIndex > 0 && this.focusedOptionIndex <= optionsNum) {
		this.focusedOptionIndex--;
	  }
	  else if (this.focusedOptionIndex == 0) {
		this.focusedOptionIndex = optionsNum;
	  }
	},
	focusNextOption() {
	  const optionsNum = Object.keys(this.filteredOptions()).length - 1;
	  if (!this.isOpen()) {
		this.open();
	  }
	  if (this.focusedOptionIndex == null || this.focusedOptionIndex == optionsNum) {
		this.focusedOptionIndex = 0;
	  }
	  else if (this.focusedOptionIndex >= 0 && this.focusedOptionIndex < optionsNum) {
		this.focusedOptionIndex++;
	  }
	},
	toggleTheme() {
		this.dark = !this.dark
		setThemeToLocalStorage(this.dark)
	},
	setDashBoardSelected(v,h){
		setPostSelectedToLocalStorage(v,h);
	},
	addVisted(d){
		setRecentedVisted(d);
	},
	checkRecentVisited(){
		if(this.recentVisited.length==0){
			return false;
		}
		var sts=false;
		if(this.recentVisited.length>0){
			this.recentVisited.forEach(element => (document.getElementById('mdasboard'+element)!=null) ? sts=true:'' )
		}
		return sts;
	}
})

